import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { FormFieldContainer } from '@bambi/component-library/src/components/forms/layout/FormFieldContainer';
import type { SupportedGridSizes } from '@bambi/component-library/src/components/forms/layout/FormFieldSet';
import { forwardRef } from 'react';

import Switch from 'src/common/primitives/Switch';

export type CoreFormFieldSwitchProps = {
  label: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  colSpan?: SupportedGridSizes;
  inline?: boolean;
  inputProps: {
    id?: string;
    disabled?: boolean;
    value?: boolean;
    onChange?: (val: boolean) => void;
  };
};

export const CoreFormFieldSwitch = forwardRef(function _CoreFormFieldSwitch(
  {
    inputProps,
    label,
    error,
    helperText,
    colSpan,
    inline,
  }: CoreFormFieldSwitchProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <FormFieldContainer colSpan={colSpan}>
      <DefaultFormFieldLayout
        label={label}
        inputId={inputProps.id}
        helperText={helperText}
        error={error}
        inline={inline}
      >
        <Switch
          data-testid={inputProps.id}
          label={label}
          inputProps={inputProps}
          ref={ref}
        />
      </DefaultFormFieldLayout>
    </FormFieldContainer>
  );
});
